/*  MUI  */
import { Alert, Typography } from '@mui/material';

/* Shared */
import { INCIDENT_IMPACT, INCIDENT_STATUS } from 'application/Shared/Constants';

/*  Hooks  */
import { useFetchAppStatus } from 'hooks/dataAccess/Application/applicationStatus';
import { useFetchUserApplications } from 'hooks/dataAccess/User/userApplication';

/*  React  */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

const alertSeverity = (impact) => {
    switch (impact) {
        case INCIDENT_IMPACT.CRITICAL:
        case INCIDENT_IMPACT.MAJOR:
            return 'error';
        case INCIDENT_IMPACT.MINOR:
            return 'warning';
        default:
            return 'info';
    }
};

export const StatusBanner = ({ applicationId }) => {
    const { t } = useTranslation();
    const { clientId } = useParams();
    const { appStatus } = useFetchAppStatus(applicationId);

    const parameters = useMemo(
        () => ({
            applicationId,
            includeAccounts: true,
            includeActiveUser: true,
            includeUncataloged: true,
            includeUnclassified: true,
            platformUserId: '*'
        }),
        [applicationId]
    );

    const { userAppsCount } = useFetchUserApplications({
        clientId,
        params: parameters
    });

    return (
        appStatus &&
        appStatus?.incidentStatus !== INCIDENT_STATUS.RESOLVED && (
            <Alert
                icon={false}
                severity={alertSeverity(
                    appStatus?.incidentImpact.toLowerCase()
                )}
                sx={{ mb: '16px' }}
            >
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Applications.incidentBanner', {
                            count: userAppsCount,
                            incidentExternalLink:
                                appStatus?.incidentExternalLink,
                            incidentImpact:
                                appStatus?.incidentImpact.toLowerCase()
                        })
                    }}
                />
            </Alert>
        )
    );
};
